/* Dauber HQ theme toggle — light / dark / system.
 * State stored in localStorage as 'dhq-theme' = 'light' | 'dark' | 'system'.
 * 'system' resolves dynamically against prefers-color-scheme.
 * The pre-body bootstrap script in _layout.twig handles initial paint.
 */

(function () {
  'use strict';

  var STORAGE_KEY = 'dhq-theme';
  var DEFAULT = 'system';
  var mql = window.matchMedia('(prefers-color-scheme: dark)');

  function getPref() {
    try { return localStorage.getItem(STORAGE_KEY) || DEFAULT; }
    catch (_) { return DEFAULT; }
  }

  function resolveTheme(pref) {
    if (pref === 'system') return mql.matches ? 'dark' : 'light';
    return pref;
  }

  function apply(pref) {
    var resolved = resolveTheme(pref);
    document.documentElement.setAttribute('data-theme', resolved);
    document.documentElement.setAttribute('data-theme-pref', pref);
    syncToggleUI(pref);
  }

  var CYCLE_ORDER = ['system', 'light', 'dark'];

  var LABELS = { system: 'Auto', light: 'Light', dark: 'Dark' };

  function syncToggleUI(pref) {
    document.querySelectorAll('[data-theme-set]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.getAttribute('data-theme-set') === pref ? 'true' : 'false');
    });
    // The cycle button has no pressed state, so carry the current theme in its
    // accessible name and keep the visible label in sync (it was static before).
    var label = LABELS[pref] || pref;
    document.querySelectorAll('[data-theme-cycle]').forEach(function (btn) {
      btn.setAttribute('aria-label', 'Theme: ' + label + '. Activate to change.');
      var lbl = btn.querySelector('.nav__theme-label');
      if (lbl) lbl.textContent = label;
    });
  }

  function setPref(pref) {
    try { localStorage.setItem(STORAGE_KEY, pref); } catch (_) {}
    apply(pref);
  }

  // Live-update when system pref changes and user is on 'system'
  mql.addEventListener('change', function () {
    if (getPref() === 'system') apply('system');
  });

  // Wire footer toggle buttons
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-theme-set]');
    if (!btn) return;
    setPref(btn.getAttribute('data-theme-set'));
  });

  // Wire nav cycle button
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-theme-cycle]');
    if (!btn) return;
    var current = getPref();
    var idx = CYCLE_ORDER.indexOf(current);
    var next = CYCLE_ORDER[(idx + 1) % CYCLE_ORDER.length];
    setPref(next);
  });

  // Set initial UI state once DOM ready (bootstrap script set the actual theme)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { syncToggleUI(getPref()); });
  } else {
    syncToggleUI(getPref());
  }
})();
